import { Component, OnDestroy, OnInit } from "@angular/core";
import { AssessmentService } from "../shared/services/assessment.service";
import { ViewStateService } from "../../shared/services/view-state.service";
import { UserService } from "../../shared/services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { NotificationsService } from "../../shared/services/notifications.service";
import { Assessment } from "../shared/models/assessment";
import { Question } from "../shared/models/question";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-review-question",
  templateUrl: "./review-question.component.html",
  styleUrls: ["./review-question.component.css"],
})
export class ReviewQuestionComponent implements OnInit, OnDestroy {
  personId: string;
  assessmentResultId: string;
  assessment: Assessment;
  totalCorrectAnswers: number;
  questionId: string;
  question: Question;
  totalQuestions: number;
  isCorrect: boolean;
  currentYear: string;
  pastAssessment: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private assessmentService: AssessmentService,
    private viewState: ViewStateService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private notifications: NotificationsService
  ) {
    this.assessment = new Assessment();
  }

  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.assessmentResultId = params["assessmentResultId"];
      this.questionId = params["questionId"];
      if (this.questionId === "1") {
        this.fetchAssessmentResult();
      } else {
        this.getQuestionDetails();
      }
    });
    this.currentYear = new Date().getFullYear().toString();
  }

  private fetchAssessmentResult() {
    this.viewState.startLoading();
    this.assessmentService
      .fetchAssessmentResult(this.personId, this.assessmentResultId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.assessment = res;
          this.pastAssessment = this.assessment.pastAssessment;
          this.viewState.stopLoading();
          if (this.questionId === "1") {
            this.questionId = this.assessment.questions[0].questionId;
            this.getQuestionDetails();
          }
          this.findCorrectAnswers();
        },
        (errors) => {
          this.handleServerErrorResponse(errors);
        }
      );
  }

  private findCorrectAnswers() {
    this.totalQuestions = this.assessment.questions.length;
    this.totalCorrectAnswers = this.assessment.questions.filter((obj) => {
      return obj.isCorrect === true;
    }).length;
  }

  private getQuestionDetails() {
    this.viewState.startLoading();
    this.assessmentService
      .getQuestionDetails(this.personId, this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (question) => {
          this.question = question;
          let obj = this.assessment.questions.find(
            (obj) => obj.sequence === this.question.sequence
          );
          this.question.isCorrect = obj.isCorrect;
          this.viewState.stopLoading();
        },
        (errors) => {
          this.handleServerErrorResponse(errors);
        }
      );
  }

  private handleServerErrorResponse(response) {
    if (response.status === 500)
      this.notifications.error(
        "Unexpected Error",
        "An unexpected error occurred. Please try again or contact NBRC for assistance."
      );
    else {
      let error = response;
      this.notifications.error("Error", error[0].message);
    }
    this.viewState.stopLoading();
  }

  blockCopy() {
    this.assessmentService
      .warnUser(this.personId, "copy", this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  blockCut() {
    this.assessmentService
      .warnUser(this.personId, "cut", this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
